
export type UpdateNotificationSettings200Frequency = typeof UpdateNotificationSettings200Frequency[keyof typeof UpdateNotificationSettings200Frequency];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateNotificationSettings200Frequency = {
  IMMEDIATE: 'IMMEDIATE',
  DAILY_DIGEST: 'DAILY_DIGEST',
} as const;
